import { render, staticRenderFns } from "./SendReport.vue?vue&type=template&id=f930f900&scoped=true"
import script from "./SendReport.vue?vue&type=script&lang=js"
export * from "./SendReport.vue?vue&type=script&lang=js"
import style0 from "./SendReport.vue?vue&type=style&index=0&id=f930f900&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f930f900",
  null
  
)

export default component.exports